import { t } from 'localization/utils/t';
import { BREADCRUMBS } from 'breadcrumbs/constants/breadcrumbs';
import { getBreadcrumbs } from 'server/utils/breadcrumbs/getBreadcrumbs';
import { FeatureFlags } from 'featureFlags/constants';
import { fetchGlobalPricingId } from 'server/utils/fetchGlobalPricingId';
import { IProductLandingPage } from 'shared/types/ProductLandingPage';
import { PlpPageComponent as PLPLandingPageComponent } from 'product-landing-pages/components/PlpPageComponent';
import { getBrowseResults } from 'server/utils/constructor/getBrowseResults';
import { isSearchCrawler } from 'shared/utils/isSearchCrawler';
import QueryString from 'qs';
import { getConsumerSearchServerSideData } from 'server/utils/getConsumerSearchDataServerSide';

const TP = 'pages.sneakers.underRetail';

const UnderRetail = ({
  breadcrumbs,
  browseKey,
  browseValue,
  constructorResponse,
  consumerSearchFilters,
  displayName,
  globalPricingId,
  isCrawler = false,
  consumerSearchInitialData = '{}',
}: IProductLandingPage) => {
  const {
    name = displayName,
    description = '',
    metadataDescription = null,
    titleTag = '',
  } = breadcrumbs || {};

  return (
    <PLPLandingPageComponent
      browseKey={browseKey}
      browseValue={browseValue}
      constructorResponse={constructorResponse}
      consumerSearchInitialData={JSON.parse(consumerSearchInitialData)}
      consumerSearchFilters={consumerSearchFilters}
      description={
        description ||
        t(
          `${TP}.description`,
          'Shop our collection of sneakers under retail and save up to 30% off.',
        )
      }
      displayName={name}
      globalPricingId={globalPricingId}
      metadataDescription={
        metadataDescription ||
        t(
          `${TP}.description`,
          'Shop our collection of sneakers under retail and save up to 30% off.',
        )
      }
      metaTitle={titleTag || t(`${TP}.underRetailWithSpace`, 'Under Retail ')}
      isCrawler={isCrawler}
    />
  );
};

export const getServerSideProps = async ({ query, resolvedUrl, req, res }) => {
  const q = QueryString.parse(query);
  const globalPricingId = await fetchGlobalPricingId({ req, res });
  const breadcrumbs = await getBreadcrumbs({
    req,
    res,
    path: `${BREADCRUMBS.SNEAKERS}/under-retail`,
  });
  const isCrawler = isSearchCrawler(req?.headers);
  const isConsumerSearchEnable =
    req.featureFlags?.[FeatureFlags.TEMP_WEB_ENABLE_SEARCH_MICROFRONTEND];

  if (isConsumerSearchEnable) {
    const consumerSearchInitialData = await getConsumerSearchServerSideData({
      filters: { ...q, pageFilters: { productTypes: 'sneakers', underRetail: 'true' } },
      pageNumber: req.query?.pageNumber || 1,
    });

    if (!consumerSearchInitialData?.items?.hasData) {
      return { notFound: true };
    }

    return {
      props: {
        breadcrumbs,
        browseKey: 'group_id',
        browseValue: 'all',
        consumerSearchFilters: { productTypes: 'sneakers', underRetail: 'true' },
        displayName: 'Under Retail',
        globalPricingId,
        isCrawler,
        consumerSearchInitialData: JSON.stringify({}),
      },
    };
  }

  try {
    const browseResponse = await getBrowseResults({
      req,
      res,
      resolvedUrl,
      query,
      filterKey: 'group_id',
      filterValue: 'all',
    });

    const invalidSearch = browseResponse.response.total_num_results === 0;

    if (invalidSearch) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        breadcrumbs,
        browseKey: 'group_id',
        browseValue: 'all',
        consumerSearchFilters: { productTypes: 'sneakers', underRetail: true },
        constructorResponse: browseResponse,
        displayName: 'Under Retail',
        globalPricingId,
        isCrawler,
      },
    };
  } catch {
    return { notFound: true };
  }
};

export default UnderRetail;
